import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Filters from '../../../components/Filters';
import PageContainer from '../../../components/PageContainer';
import { connect } from 'react-redux';
import CaseTable from '../../../components/CaseTable';
import { getLoggedInUserAssignedCases } from '../../../redux/api/cases';
import { useSnackbar } from 'notistack';
import { getAllSubcategories } from '../../../redux/api/userMgt';

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div role="tabpanel" hidden={value !== index} {...other}>
            {value === index && <Box>{children}</Box>}
        </div>
    );
};

const MyCases = ({ user }) => {
    const [open, setOpen] = useState(false);
    const [processing, setProcessing] = useState(false);
    const [userData, setUserData] = useState({});
    const [parentRoleUsers, setParentRoleUsers] = useState([]);
    const [childRoleUsers, setChildRoleUsers] = useState([]);
    const [paginationData, setPaginationData] = useState({});
    const [subCategories, setSubCategories] = useState([]);
    const { enqueueSnackbar } = useSnackbar();

    const defMessage = { subject: '', message: '' };

    const [records, setRecords] = useState([]);

    const init = async (start = 0, length = 50) => {
        try {
            setProcessing(true);
            const res = await getLoggedInUserAssignedCases({ start, length });
            const resp = await getAllSubcategories();
            setSubCategories(resp?.resultObject || []);
            setRecords(
                records?.length < start
                    ? res?.resultObject?.dataTableResponse?.data || []
                    : records.concat(
                          res?.resultObject?.dataTableResponse?.data || []
                      )
            );
            setChildRoleUsers(res?.resultObject?.childRoleUsers || []);
            setParentRoleUsers(res?.resultObject?.parentRoleUsers || []);

            setPaginationData({
                start,
                length,
                total: res?.resultObject?.dataTableResponse?.recordsTotal,
                totalFiltered:
                    res?.resultObject?.dataTableResponse?.recordsFiltered,
            });
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        } finally {
            setProcessing(false);
        }
    };

    const exportData = async () => {
        try {
            const resp = await getLoggedInUserAssignedCases({}, true);
            enqueueSnackbar(
                resp?.message ||
                    'Your report is being processed, kindly check the reports page for progress'
            );
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        }
    };

    const search = async (values, closeSearchModal) => {
        try {
            const res = await getLoggedInUserAssignedCases(values);
            if (res?.statusCode == '000') {
                setRecords(res?.resultObject?.data || []);
                closeSearchModal();
            } else {
                enqueueSnackbar(res?.message || 'An error occurred', {
                    variant: 'info',
                });
            }
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        }
    };

    useEffect(() => {
        init();
    }, []);

    useEffect(() => {
        setUserData(user.userData);
    }, [user]);

    return (
        <PageContainer pageTitle="My Owned Cases" processing={processing}>
            {/* <Filters 
                searchFields={[
                    { id: 'user_id', label: 'Case ID' },
                    { id: 'user_id', label: 'Tracking Reference Number' },
                    { id: 'account_status', label: 'Name of Complainant' },
                    { id: 'name', label: 'Unique Identification No.' },
                    { id: 'employee_id', label: 'Submission Date' },

                ]}
                // searchFunction={searchFunction}
            
            /> */}

            <CaseTable
                cases={records}
                initFunction={init}
                parentRoleUsers={parentRoleUsers}
                childRoleUsers={childRoleUsers}
                exportFunction={exportData}
                returnToFiBtn
                searchFunction={search}
                paginationData={paginationData}
                sendMessageBtn
                subCategories={subCategories}
                showRecategorizeCaseBtn
            />
        </PageContainer>
    );
};

export default connect(({ user }) => ({ user }))(MyCases);
